import { ConditionEvaluator } from '@leverege/condition';
import { evaluate } from 'mathjs';
export default class UnitGreaterThanComparatorEvaluator extends ConditionEvaluator {
  satisfies(context) {
    const {
      attribute,
      target
    } = context;
    const targetRaw = attribute?.get(target?.data);
    const targetValue = targetRaw?.value;
    const targetUnit = targetRaw?.unit;
    const value1 = this.model.value1;
    const cmp = '>';
    const value1Value = value1?.value;
    const value1Unit = value1?.unit;
    if (targetValue == null) {
      return null;
    }
    return evaluate(`${targetValue} ${targetUnit} ${cmp} (${value1Value} ${value1Unit || targetUnit} to ${targetUnit})`);
  }
}